import PropTypes from 'prop-types';

export const visibilitiesRosterType = PropTypes.shape({
  id: PropTypes.string.isRequired,
  roster: PropTypes.bool,
  bioSection: PropTypes.bool,
  metricsSection: PropTypes.bool,
  demographicsSection: PropTypes.bool,
  platformsSection: PropTypes.bool,
});
